import { Platform, StyleSheet } from "react-native";

const styles = StyleSheet.create({
  content: {
    alignSelf: "center",
    width: 340,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    paddingHorizontal: 25,
    paddingTop: 24,
    paddingBottom: 24,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  contentBtn: {
    marginTop: 20,
    width: 326,
    marginBottom: 10,
  },
  btn: {
    width: 300,
    height: 48,
    padding: 14,
    borderRadius: 4,
    backgroundColor: "#077A97",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },

  tituloAtualizarCadastro: {
    textAlign: "left",
    color: "#077A97",
    fontSize: 18,
    flexDirection: "row",
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  contentBtnDelete: {
    // position: 're',
    // bottom: 30,
    marginTop: 10,
    paddingHorizontal: 25,
    width: "100%",
    marginBottom: 20,
  },
  textBtnDelete: {
    color: "#BC1010",
    textAlign: "center",
    textDecorationLine: "underline",
    fontWeight: "normal",
  },
  containerSocialContract: {
    width: 326,
    paddingRight: 25,
    marginTop: 20,
  },
  description: {
    textAlign: "justify",
    textTransform: "uppercase",
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 15,
  },

  iconAdd: {
    textAlign: "center",
    marginTop: 5,
  },
  modalCenteredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
    backgroundColor: "rgba(0,0,0,.6)",
  },
  closeModal: {
    marginLeft: "auto",
    marginRight: -10,
    marginTop: -5,
  },
  modalView: {
    marginTop: 20,
    backgroundColor: "#ffffff",
    borderRadius: 10,
    paddingHorizontal: 35,
    paddingVertical: 15,
    alignItems: "center",
    overflow: "hidden",
    shadowOpacity: 0.2,
    shadowColor: "#000",
    shadowRadius: 0,
    shadowOffset: {
      width: 0,
      height: 0,
    },
  },
  modalText: {
    width: "100%",
    backgroundColor: "#fff",
    marginVertical: 30,
    textAlign: "center",
    alignContent: "center",
  },
  button: {
    borderRadius: 10,
    padding: 10,
    marginTop: 25,
    outlineWidth: 0,
    borderWidth: 0,
    elevation: 2,
  },

  btnAdd: {
    height: 300,
    width: "100%",
    borderColor: "#077A97",
    borderWidth: 0.5,
    borderRadius: 4,
    marginTop: 20,
    alignItems: "center",
    justifyContent: "center",
  },

  imgUpload: {
    width: 160,
    height: 160,
    tintColor: "#077A97",
  },

  uploadText: {
    marginTop: 10,
  },
});

export default styles;
